<template>
  <vh-container class="layout-container">
    <!-- 左侧菜单栏 -->
    <SideBar></SideBar>

    <!-- 右侧功能区 -->
    <vh-container class="layout-main">
      <HeadBar v-if="$isWxwork"></HeadBar>
      <div class="video-workspace">
        <!-- 功能介绍 -->
        <div class="video-workspace__header">
          <router-view name="intro"></router-view>
        </div>
        <!-- 主操作区 -->
        <div class="video-workspace__body">
          <div class="video-main">
            <!-- 视频播放区 -->
            <div class="video-side">
              <!-- 标题 -->
              <div class="video-title">
                <span class="video-title__label">{{ $t('ai.k_019001') }}</span>
                <vh-tooltip class="item" effect="dark" placement="top">
                  <div slot="content" style="width: 241px">
                    {{ recordName }}
                  </div>
                  <v-clamp class="video-title__text" :max-lines="1">
                    {{ recordName }}
                  </v-clamp>
                </vh-tooltip>
              </div>
              <div class="video-player-wapper">
                <ai-video-player></ai-video-player>
                <vh-tabs v-model="activeName" v-show="sideTabAlign === 'horizontal'">
                  <vh-tab-pane :label="$t('ai.k_019002')" name="first"></vh-tab-pane>
                  <vh-tab-pane
                    :label="$t('ai.k_019003')"
                    name="second"
                    v-if="hasVodDoc"
                  ></vh-tab-pane>
                </vh-tabs>
              </div>
              <AiDoc v-show="activeName === 'second' && hasVodDoc"></AiDoc>
              <router-view v-show="showAsrRouterView" name="asr"></router-view>
            </div>
            <!-- 智能处理 -->
            <div class="video-process">
              <router-view></router-view>
            </div>
          </div>
        </div>
      </div>
    </vh-container>
  </vh-container>
</template>
<script>
  import SideBar from '../components/SideBar.vue';
  import HeadBar from '@/components/HeadBar.vue';
  import AiVideoPlayer from '@/components/AiVideoPlayer.vue';
  import AiDoc from '@/components/AiDoc.vue';
  import { getRecordAsr, doParsingAsrResult } from '@/biz/record';
  import { initMsgChat } from '@/biz/base';
  import VClamp from 'vue-clamp';

  export default {
    name: 'MainLayout',
    components: {
      VClamp,
      SideBar,
      HeadBar,
      AiVideoPlayer,
      AiDoc
    },
    data() {
      return {
        showTab: true,
        activeName: 'first'
      };
    },
    computed: {
      hasVodDoc() {
        return this.$store.state.video.hasVodDoc;
      },
      showAsrRouterView() {
        return (
          this.sideTabAlign === 'vertical' ||
          (this.sideTabAlign === 'horizontal' && this.activeName === 'first')
        );
      },
      sideTabAlign() {
        return this.$route.meta.sideTabAlign;
      },
      recordName() {
        return this.$store.state.video.recordInfo?.name || '';
      },
      revoId() {
        return this.$isEmbed
          ? this.$store.state.video.recordInfo?.vod_id
          : this.$store.state.video.recordInfo?.id;
      }
    },
    watch: {
      sideTabAlign: {
        handler(newVal) {
          this.activeName = newVal === 'horizontal' ? 'first' : 'second';
        },
        immediate: true
      }
    },
    beforeCreate() {
      initMsgChat();
    },
    async created() {
      this.initEvent();

      // 获取初始化解析结果
      await getRecordAsr(this.revoId);
    },
    methods: {
      initEvent() {
        this.$emitter.on(this.$EMIT_DEFINE.msgVodAiParsingAsrComplete, this.vodAsrComplete);
        this.$emitter.on(this.$EMIT_DEFINE.changeMomentFilter, this.showFullTextTab);
        this.$emitter.on(this.$EMIT_DEFINE.clipAddGuide, this.showFullTextTab);
      },
      vodAsrComplete(data) {
        if (data && (data.record_id == this.revoId || data.vod_id == this.revoId)) {
          doParsingAsrResult(data, true);
        }
      },
      // 显示全文内容 tab
      showFullTextTab() {
        this.activeName = 'first';
      }
    },
    beforeDestroy() {
      this.$emitter.off(this.$EMIT_DEFINE.msgVodAiParsingAsrComplete, this.vodAsrComplete);
      this.$emitter.off(this.$EMIT_DEFINE.changeMomentFilter, this.showFullTextTab);
      this.$emitter.off(this.$EMIT_DEFINE.clipAddGuide, this.showFullTextTab);
    }
  };
</script>
<style lang="less" scoped>
  .layout-container {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: row;
    box-sizing: border-box;
    overflow: hidden;
    background-color: #f7f7f7;

    .layout-main {
      flex: 1;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .video-workspace {
      flex: 1;
      box-sizing: border-box;
      padding: 0;
      display: flex;
      flex-direction: column;
      width: 100%;
      height: 100%;
      margin-top: 16px;
      padding: 0 16px 0 16px;

      &__header {
        height: 84px;
        background: #fff;
        border-radius: 12px;
      }

      &__body {
        flex: 1;
        display: flex;
        flex-direction: column;
        height: 100%;
        box-sizing: border-box;
        overflow: hidden;
        min-width: 460px;
        margin-top: 16px;

        .video-main {
          display: flex;
          box-sizing: border-box;
          flex-direction: row;
          flex: 1;
          height: 100%;
          overflow: hidden;
          margin-bottom: 6px;

          // 视频播放区域
          .video-side {
            padding: 0;
            margin: 0;
            width: 384px;
            min-width: 384px;
            height: 100%;
            background-color: #fff;
            box-sizing: border-box;
            border-radius: 12px;
            padding: 24px;
            display: flex;
            flex-direction: column;

            .video-title {
              width: 100%;
              font-size: 16px;
              font-style: normal;
              font-weight: 600;
              line-height: 24px;
              padding-bottom: 12px;
              display: flex;
              flex-direction: row;

              &__label {
                color: #565656;
              }
              &__text {
                flex: 1;
                color: #262626;
                font-weight: bold;

                span {
                  font-weight: bold;
                }
              }
            }

            .video-player-wapper {
              display: inline-block;
            }
            .video-asr-wapper {
              display: inline-block;
            }
          }

          .video-process {
            box-sizing: border-box;
            background-color: #fff;
            flex: 1;
            margin-left: 16px;
            border-radius: 12px;
            min-width: 460px;
          }
        }
      }
    }
  }
</style>
